import { Box } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheetIllustrationContent, Title } from "@src/appV2/redesign/system/ui-components";
import { type NfcTagRequest } from "@src/appV2/Shifts/Shift/types";

import type { NfcHashValidationAction } from "../api/types";
import { NfcLocationsDescription } from "../NfcLocationsDescription";
import { clockActionToReadableString } from "../utils";

export interface BeginScanStageProps {
  clockAction: NfcHashValidationAction;
  workplaceName: string;
  nfcTagRequests: NfcTagRequest[];
  isMissedPunchRequestEnabled: boolean;

  onStartScan: () => void;
  onCancel: () => void;
  onHelpScanningPoster: () => void;
}

export function BeginScanStage(props: BeginScanStageProps) {
  const {
    clockAction,
    workplaceName,
    nfcTagRequests,
    isMissedPunchRequestEnabled,
    onStartScan,
    onCancel,
    onHelpScanningPoster,
  } = props;

  return (
    <>
      <BottomSheetIllustrationContent
        illustrationType="nfc-poster"
        title={
          <Title variant="h3" component="h1">
            {clockActionToReadableString(clockAction)}
          </Title>
        }
        description={
          <Box px={9}>
            <NfcLocationsDescription
              workplaceName={workplaceName}
              nfcTagRequests={nfcTagRequests}
            />
          </Box>
        }
      />

      <DialogFooter
        orientation="vertical"
        closeButtonAriaLabel="Cancel"
        onClose={() => {
          onCancel();
        }}
      >
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={() => {
            onStartScan();
          }}
        >
          Scan poster
        </Button>

        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={() => {
            onHelpScanningPoster();
          }}
        >
          {isMissedPunchRequestEnabled ? "I can't scan the poster" : "I need help"}
        </Button>
      </DialogFooter>
    </>
  );
}
